import Page from "modules/app/components/Page"
import s from './ProductsByCategory.module.scss'
import TopMenuForShop from "modules/feed/components/Feed/TopMenuForShop/TopMenuForShop"
import { useTypedSelector } from 'store/useTypedSelector'
import { useActions } from 'store/useActions'
import ShoppingCart from "../ShoppingCart"
import { useNavigate, useParams } from "react-router-dom"
import useGetProductCategories from "sdk/hooks/shop/useGetProductCategories"
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import { useState, useRef, useEffect, useMemo } from "react"
import useAddProductToBasket from "sdk/hooks/shop/useAddProductToBasket"
import useIsAuth from "sdk/hooks/useIsAuth"
import useGetProductsByCategoryId from "sdk/hooks/shop/useGetProductsByCategoryId"
import useGetAllBrands from "sdk/hooks/shop/useGetAllBrands"
import ProductCard, { Product } from "./ProductCard"
import TopMenuProductCategory from "./TopMenuProductCategory"
import BrandFilter from './BrandFilter'
import useGetOrdersInTheCart from "sdk/hooks/shop/useGetOrdersInTheCart"
import BtnGotoSomewhere from "../ShoppingCart/BtnGotoSomewhere"
import { useTranslation } from "react-i18next"


export const normalizeProduct = (p: any): Product => ({
  id: Number(p.id),
  image: p.image || "",
  name: p.name || "",
  sku: p.sku || "",
  created_at: p.created_at || "",
  currency: Number(p.currency) || 1,
  description: p.description || "",
  stats: p.stats ?? null,
  active: Boolean(p.active),
  unique_name: p.unique_name || "",
  category_id: Number(p.category_id) || 0,
  desc_details: p.desc_details ?? null,
  price: Number(p.price) || 0,
  in_stock: p.in_stock ?? null,
  salon: Number(p.salon) || 0,
  stock_quantity: Number(p.stock_quantity) || 0,
  min_stock_level: p.min_stock_level ?? null,
  reorder: p.reorder ?? null,
  brand: Number(p.brand) || 0,
  original_price: p.original_price || null,
  updated_at: p.updated_at || "",
  subcategory_id: Number(p.subcategory_id) || 0,
  instruction: p.instruction ?? null,
  ingredients: p.ingredients ?? null,
  store_id: p.store_id ? Number(p.store_id) : null,
  applicable_gender: p.applicable_gender ?? 3,
  name_ar: p.name_ar ?? null,
});


const ProductsByCategory = () => {
    const {t} = useTranslation() as any
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { isOpenBasket } = useTypedSelector((state) => state.postSlice)
  const { setIsOpenBasket } = useActions()
  const navigate = useNavigate()
  const { id } = useParams()
  const categoryId = id ? parseInt(id, 10) : null;
const { data: categories, isLoading } = useGetProductCategories();
  const { data: brands } = useGetAllBrands();
  const { data: products } = useGetProductsByCategoryId(categoryId)
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);
  const [showBrandsDropdown, setShowBrandsDropdown] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState('All'); 

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowBrandsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const categoriesNormalized = categories?.map(cat => ({
  id: cat.id,
  name: cat.name,
})) || [];



  const filteredProducts = useMemo(() => {
    if (!products) return [];
    if (selectedBrand === 'All') return products;

    return products.filter((product) => {
      const brandObj = brands?.find((b) => b.id === product.brand);
      return brandObj?.name === selectedBrand;
    });
  }, [products, selectedBrand, brands]);


const filteredProductsNormalized: Product[] = filteredProducts.map(normalizeProduct);


    //fetch cart items to check the count of items
      const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);
    
      useEffect(() => {
        refetchCart();
      }, [userId]);

      interface CartItem {
        count: number;
        price?: number;
        product?: {
          price?: number;
        };
      }
      const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
    const displayCount = itemCount > 99 ? '99+' : itemCount;
    const cartTotal = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => {
      const price = item.price || item.product?.price || 0;
      return total + (item.count || 0) * price;
    }, 0) || 0;
   

  return (
    <div style={{ overflow: 'auto' }}>
    
      <Page disableOverflow activeLink="/shop">
        <TopMenuProductCategory onOpen={setIsOpenBasket} />
        <div
          className={s.shop}
        >
        </div> 
        <div className={s.container}>
          <div className={s.products_title}>
            {t(categoriesNormalized?.find((category) => category.id === Number(id))?.name)}
          </div>
          <BrandFilter
            selectedBrand={selectedBrand}
            setSelectedBrand={setSelectedBrand}
            showBrandsDropdown={showBrandsDropdown}
            setShowBrandsDropdown={setShowBrandsDropdown}
            brands={brands as Array<{ id: number; name: string }>}
          />
          <div className={s.grid}>
           {filteredProductsNormalized.map(item => (
  <ProductCard key={item.id} product={item as Product} userId={userId} />
))}

          </div>
        </div>
          {/* {displayCount > 0 && (
          <BtnGotoSomewhere link={() => setIsOpenBasket(false)} title={`Go to Cart ${displayCount} items, cost is ${cartTotal} `} style={{ position: 'fixed', bottom: '90px' }}/>
          )} */}
          </Page>
      <ShoppingCart open={isOpenBasket} setOpenShoppingCartMenu={setIsOpenBasket} />
          
    </div>
  );
};

export default ProductsByCategory;